import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Stack, Box, Fade } from "@mui/material"
import Divider from '@mui/material/Divider';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useAlert } from '../../components/AlertProvider/AlertProvider';
import { fetchRecommand, updateSearchObject, updateSearchValue } from '../../store/features/search';
export default function Example() {
  const { localSearch, recommandSearch } = useSelector((store) => store.search);
  const dispatch = useDispatch();
  const [show, SetShow] = useState(false);
  const { mapData } = useSelector(store => (store.maps));
  const showAlert = useAlert();

  console.log("localSearch:", localSearch.length)
  const navigate = useNavigate();
  useEffect(() => {
    //显示推荐搜索的内容
    SetShow(true);
    dispatch(fetchRecommand());
  }, []);

  const Item = ({ onClick, children }) => {
    return (
      <div onClick={onClick} className='border p-2 rounded-lg' style={{ color: '#777' }}>{children}</div>
    );
  };

  const clickHandler = (keyword) => {
    navigate(`/yetai?type=0&keyword=${keyword}`);
    return;
    if (mapData) {
      let answer = mapData.find((item) => {
        return item.name == keyword
      });
      if (answer) {
        dispatch(updateSearchValue(answer.name));
        dispatch(updateSearchObject(answer));
        navigate(`/home`);
      }
      else {
        console.log('没有找到');
        showAlert('找不到该村庄信息');
      }
    }
  

   
  }

  return (
    <Fade in={show}>
      <Container className='text-mblack' sx={{ marginTop: '5rem' }}>
        <Box className='mt-2 mb-2' sx={{ fontSize: "0.8rem" }}>历史记录</Box>

        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {
            (localSearch && localSearch.length > 0) ?
              localSearch.map((item, index) => (
                <Item key={index} onClick={() => clickHandler(item)}>{item}</Item>
              )) :
              <div>无</div>
          }
        </Stack>

        <Box className='mt-5 mb-2' sx={{ fontSize: "0.8rem" }}>搜索推荐</Box>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {
            (recommandSearch && recommandSearch.length > 0) ?
              recommandSearch.map((item, index) => (
                <Item key={index} onClick={() => clickHandler(item.name)}>{item.name}</Item>
              )) :
              <div>无</div>
          }
        </Stack>
      </Container >
    </Fade>
  );
}